<div class="card product-card">
  <div class="card-body">
    <div class="image-wrapper" [routerLink]="['/product/', data.product.id]">
      <div>
        <span class="return-policy"
          *ngIf="data.product.extra.validForReturnMap && data.product.extra.validForReturnMap[customerPriceList] && data.product.extra.validForReturnMap[customerPriceList] == '1'">
          {{ 'RETURN_VALID' | translate }}
        </span>
      </div>
      <img class="img-fluid" *ngIf="data.product.extra && data.product.extra.images && data.product.extra.images[0]"
        src="https://cdn3.gung.io/fit-in/250x250/filters:etag({{
          data.product.extra.images[0].s3ETag
        }}):background_color(white):format(jpeg):fill(fff)/{{ data.product.extra.images[0].s3Uri }}" alt="" />
    </div>
    <div class="product-text pb-1">
      <div>{{ data.product.id }}</div>
      <div class="small" *ngIf="data.product.extra.pim?.ar_q_wa_eankod_konsument">
        <span>
          <span translate>EAN</span>:&nbsp;<span>{{ data.product.extra.pim.ar_q_wa_eankod_konsument }}</span>
        </span>
      </div>
      <div class="text-truncate" translate>{{ data.product.name }}</div>
      <!--<div class="d-block" *ngFor="let value of data.product.dynamicCollumnsValues">{{value}}</div>-->
      <div translate *ngIf="data.price && !isReturNoPrice" class="font-weight-bold"
        [ngClass]="{ 'is-clearance': !isReturnFlow && data.product.extra.ar.q_eliasson_artnr === '50' }">
        {{ data.price.customerNetPrice.value | gungCurrency: data.price.customerNetPrice.currencyCode }}
      </div>
      <lib-availability [availability]="data.availability" [isSales]="isSales" *ngIf="includeAvailability">
      </lib-availability>
      <div class="product-card-button pt-2">
        <cult-buy-btn [id]="data.product.id" [product]="data.product"></cult-buy-btn>
      </div>
    </div>
  </div>
</div>